export const CSRFKey = "_csrf";
export const csrfCountMax = 10;
